var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_5898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4563 5.73125L10.5188 1.79375C10.4063 1.68125 10.2937 1.625 10.125 1.625H4.5C3.88125 1.625 3.375 2.13125 3.375 2.75V16.25C3.375 16.8687 3.88125 17.375 4.5 17.375H13.5C14.1187 17.375 14.625 16.8687 14.625 16.25V6.125C14.625 5.95625 14.5688 5.84375 14.4563 5.73125ZM10.125 2.975L13.275 6.125H10.125V2.975ZM13.5 16.25H4.5V2.75H9V6.125C9 6.74375 9.50625 7.25 10.125 7.25H13.5V16.25Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 12.875H5.625V14H12.375V12.875Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9.5H5.625V10.625H12.375V9.5Z",
    fill: "#DCE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_5898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInfo);
export default __webpack_public_path__ + "static/media/project_info.a344eff0a78fd94188bb0ac25d575089.svg";
export { ForwardRef as ReactComponent };